<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{ $route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <item-relate-component :item-key="itemKey" :itemModel="itemModel"></item-relate-component>
                    <div class="mt15 text_center">
                        <el-button @click="submitForm()" type="primary">저장</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ItemRegisterComponent from "@/components/item/ItemRegisterComponent";
import ItemRelateComponent from "@/components/item/ItemRelateComponent";
import EventBus from "@/mixins/event-bus";

export default {
    name: "ItemRelate",
    mixins: [],
    components: {
        ItemRelateComponent,
        ItemRegisterComponent
    },
    props: {},
    data() {
        return {
            itemKey: this.$route.params.i_idx,
            itemModel: this.$route.params.i_model,
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        submitForm() {
            EventBus.$emit('updateItem')
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
